<template>
  <slot name="button"></slot>
</template>

<script>
export default {
  props: {
    overlay: String
  },

  methods: {
    popup: function () {
      const overlay = document.getElementById(this.overlay);
      overlay.classList.contains('active') ?
        overlay.classList.remove('active') :
        overlay.classList.add('active')
    }
  }
}
</script>
